import NylasAvailability from './NylasAvailability';

export default NylasAvailability;
